export default "__VITE_ASSET__DbcjWeP1__"